export const UpdateProgramPopupTestIds = {
  CANCEL_BUTTON: 'update-program-popup.cancel-button',
  SAVE_WITHOUT_PROGRAM_BUTTON: 'update-program-popup.save-without-program-button',
  SELECT_NEW_PROGRAM_BUTTON: 'update-program-popup.select-new-program-button',
};
